import { Component, input, output, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule, MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

export type LTButtonToggleOption = {
  value: string | number | boolean;
  label: string;
  icon?: string;
  iconClass?: string;
  disabled?: boolean;
  tooltip?: string;
};

@Component({
  selector: 'app-lt-button-toggle',
  imports: [CommonModule, MatButtonToggleModule, MatIconModule, MatTooltipModule],
  templateUrl: './lt-button-toggle.component.html',
  styleUrl: './lt-button-toggle.component.scss',
  standalone: true,
})
export class LTButtonToggleComponent {
  readonly options = input.required<LTButtonToggleOption[]>();
  readonly multiple = input<boolean>(false);
  readonly vertical = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly hideSingleSelectionIndicator = input<boolean>(true);
  readonly hideMultipleSelectionIndicator = input<boolean>(true);
  readonly groupClass = input<string>('');
  readonly buttonClass = input<string>('');
  readonly iconClass = input<string>('');
  
  // Two-way binding for the selected value(s)
  readonly value = model<any>();
  
  valueChange = output<any>();
  selectionChange = output<any>();
  
  handleValueChange(event: MatButtonToggleChange) {
    const newValue = event.value;
    this.value.set(newValue);
    this.valueChange.emit(newValue);
    this.selectionChange.emit(newValue);
  }
}
